import './App.css';
import ParkingComplaintForm from './components/ParkingComplaintForm';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <div className="container">
        <ParkingComplaintForm />
      </div>
    </div>
  );
}

export default App;
